// @ts-nocheck
import React from 'react'
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  CustomHeader,
  LastSeenCell,
  DateCell,
  NumberCell,
  IdentityCell,
  ActionsCell
} from '@/components/table/columns'

import {StatusCell} from './CustomerCells'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
}

const usersColumns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-125px sortable' />,
  id: 'username',
  Cell: ({...props}) =>
    <IdentityCell
      avatar={props.data[props.row.index].avatar}
      email={props.data[props.row.index].email}
      displayName={props.data[props.row.index].username}
      to={`/p2c/customers/${props.data[props.row.index]._id}/overview`}
    />
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Creation Date" className='min-w-125px' />,
  id: 'createdAt',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].createdAt} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Last seen' className='min-w-125px sortable' />,
  id: 'lastSeen.date',
  Cell: ({...props}) => <LastSeenCell value={props.data[props.row.index]?.lastSeen} />
}, {
  Header: (props) =>  <CustomHeader tableProps={props} title='Balance' className='min-w-125px sortable' />,
  id: 'balance',
  Cell: ({...props}) => (
    <NumberCell value={props.data[props.row.index].balance} />
  )
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'exit-right-corner',
        label: 'View',
        navigate:  `/p2c/customers/${props.data[props.row.index]._id}/overview`
      }]}
    />
  )
}]

export {usersColumns}
